import Field from "./components/Field";
import { FeedbackChangeHandler, FeedbackData } from "./fields/fields.types";
import { FeedbackField } from "./types/feedback.types";
import get from 'lodash/get'

export type FormErrors = Record<string, boolean>;

type FeedbackFormProps = {
  data: FeedbackData;
  errors: FormErrors;
  fields: FeedbackField[];
  onChange: FeedbackChangeHandler;
};


const FeedbackForm = ({
  data,
  errors,
  fields,
  onChange,
}: FeedbackFormProps): JSX.Element => {
  return (
    <>
      {fields.map((field, index) => (
        <Field
          key={index}
          field={field}
          data={data}
          error={get(errors, field._id || field.name)}
          onChange={onChange}
        />
      ))}
    </>
  );
};

export default FeedbackForm;
